var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogurt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#29384F;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#B6D6E9;}\n\t.st4{fill:none;stroke:#E2E1E1;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.41,153.06c-40.47,0-45.99-40.58-45.99-51.4h91.99C151.41,107.07,146.11,153.06,105.41,153.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.41,101.81c0,14.11-20.59,25.55-45.99,25.55c-25.4,0-45.99-11.44-45.99-25.55s19.99-8.96,45.39-8.96 C130.21,92.85,151.41,87.7,151.41,101.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.41,123.3c-7.38,0-14.85-1.38-21.88-3.6c-6.45-2.04-13.51-4.95-18.09-10.15 c-4.06-4.61-5.26-13.86,1-17.23c2.35-1.26,4.69-1.01,7.23-1.35c3.53-0.48,6.25-2.51,9.11-4.46c4.05-2.76,9.39-1.72,13.8-3.6 c2.51-1.07,4.42-2.67,5.82-4.9c2.33-3.7,7.52-6.6,10.82-5.99c0,0-2.17,6.15,0.13,9.57c2.31,3.42,5.33,6.54,12.61,7.21 c5.51,0.51,18.74,2.02,21.4,5.63c4.31,5.83,0.04,14.19-4.74,18.1c-5.86,4.8-13.54,7.35-20.84,8.94 C116.43,122.66,110.92,123.3,105.41,123.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M156.61,61.93l-29.53,29.53c-1.26,1.26-3.32,1.26-4.58,0l-0.99-0.99c-1.26-1.26-1.26-3.32,0-4.58l29.53-29.53 c1.26-1.26,3.32-1.26,4.58,0l0.99,0.99C157.87,58.61,157.87,60.67,156.61,61.93z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -30.3122 112.0997)",
    className: "st3",
    cx: 120.16,
    cy: 92.64,
    rx: 11.98,
    ry: 11.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2322 -0.9727 0.9727 0.2322 -6.07 190.2211)",
    className: "st2",
    cx: 117.45,
    cy: 98.96,
    rx: 9.84,
    ry: 17.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.48,93.17c-2.97,6,1.22,12.45,6.74,14.96c7.47,3.39,15.67,5.19,23.87,5.41c7.24,0.2,15.7-0.5,22.25-3.88 c2.79-1.44,8.25-6.47,6.49-10.09c-1.22-2.51-5.67-2.52-7.99-2.43c-3.63,0.14-7.16,1.13-10.74,1.6c-9.99,1.33-19.07,2.08-21.93-1.43 c-2.86-3.51,1.6-9.25,1.6-9.25"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogurt);
export default __webpack_public_path__ + "static/media/Yogurt.a91ca9b05dec63ef0bbfab0221851370.svg";
export { ForwardRef as ReactComponent };